<template>
    <div id="app">
        <router-view v-if="isRouterAlive" v-wechat-title="$route.meta.title" />
    </div>
</template>
<script>
    import $ from 'jquery';
    import {getPayInfo} from './api/cashApply';
    export default {
        name: 'App',
        provide() {
            return{
                reload: this.reload
            }
        },
        data(){
            return{
                //shiming:true,
                beforeUnload: '',
                Handler: '',
                timeOut:'',
                lastTimeStoreId: 'lastTime_jc',
                closeSearch:false,
                isRouterAlive: true
            }
        },
        mounted() {
            
            //plus.navigator.setStatusBarBackground('#fff');
            let that = this;
            that.timeOut=60*60*1000;// 设置超时时间： 60分种 timeOut : 30 * 1000, 
            // 每30秒 调用检查时间的方法
            that.setLastTime();
            that.$nextTick(function () {
                setInterval(this.checkTimeout,10000);
                // setInterval(this.checkTimeout, 1000);
            }); 
            // 页面监听 按下鼠标更新操作时间
            window.onload = function () {
                window.document.onmousedown = function () {
                    that.setLastTime();
                }
                window.document.onkeydown = function () {
                    that.setLastTime();
                }
            }; 
            /*window.onmousedown = function(e){
                if (event.button == 2){ //单击的鼠标键为右键   
                    confirm('禁止右键操作！');
                    return false;
                }
            }; //绑定禁用鼠标右键事件
            window.onkeydown = function(e){
                 
                if (event.keyCode == 123) { //禁用F12查看源代码
                    alert('禁止查看源代码！');
                    return false;
                }
            }; //绑定禁用键盘事件 */

        },
        destroyed() {
            window.removeEventListener('beforeunload', e => this.beforeunloadHandler(e))
            window.removeEventListener('unload', e => this.unloadHandler(e))
        },


        methods: { 
            
            reload () {
                this.isRouterAlive = false;
                this.$nextTick(function () {
                    this.isRouterAlive = true
                })
            },
             // 存储当前时间
            setLastTime() { 
                let times = new Date().getTime();
                
                localStorage.setItem("lastOperTime111",times);
            },
            // 获取时间
            getLastTime() {   
                return localStorage.getItem("lastOperTime111");
            },
            // 删除
            removeLastTime() { 
                localStorage.removeItem("lastOperTime111")
            },
          
            checkTimeout() {
                // 登录页面不监听
                //this.$message({ type: 'warning', message: this.$route.path });
                if(this.timeOut && this.$route.path == '/login') {
                   // this.setLastTime();  
                }else {  
                    //检查是否实名
                    /*if(this.$route.path != '/user'){
                        if(this.shiming){
                            this.realName(); 
                        } 
                    } */
                    //更新当前时间
                    let currentTime = new Date().getTime();
                    let lastTime = this.getLastTime();
                    //this.$message({ type: 'warning', message: currentTime+'--'+lastTime+'--'+ this.timeOut});
                    // console.log(currentTime, lastTime, (currentTime - lastTime), this.timeOut);
                    //判断是否超时
                    if (currentTime - lastTime > this.timeOut) { 
                        localStorage.removeItem(window.location.hostname+'_loginName');  
                        localStorage.removeItem(window.location.hostname+'_phone');  
                        localStorage.removeItem(window.location.hostname+'_mid');  
                        localStorage.removeItem(window.location.hostname+'_avatar');   
                        localStorage.removeItem(window.location.hostname+'_rcode');  
                        localStorage.removeItem(window.location.hostname+'_token');   
                        localStorage.removeItem(window.location.hostname+'_items');
                        localStorage.removeItem(window.location.hostname+'_stationName');
                        localStorage.removeItem(window.location.hostname+'_stationLogo');
                        this.$router.push('/login');  
                        this.$message({ type: 'warning',message: '界面超过1小时未操作，需重新登录',showClose:true,duration:30000 });
                        this.$router.push('/login');  
                    }
                }
            }, 
        },
    }

    
 
    
</script>  
<style>
@import "./assets/css/main.css";
@import "./assets/css/theme.css";
@import "./assets/css/color-dark.css";     /*深色主题*/
    /*@import "./assets/css/theme-green/color-green.css";   /*浅绿色主题*/
</style>
